

































































import {Component, Vue, Watch} from "vue-property-decorator";
import TimeTrackingStatisticsToday from "@/views/Service/TimeTracking/Statistics/TimeTrackingStatisticsToday.vue";
import Panel from "@/components/Panel/Panel.vue";
import {Action, Getter} from "vuex-class";
import TimeTrackingStatisticsCard from "@/views/Service/TimeTracking/Statistics/TimeTrackingStatisticsCard.vue";
import Input from "@/components/Form/elements/Input.vue";
import AppConfig from "@/config/AppConfig";
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import Dropdown from "@/components/Dropdown/Dropdown.vue";
import DropdownItem from "@/components/Dropdown/DropdownItem.vue";
import Tabs from "@/components/Tabs/Tabs.vue";
import Tab from "@/components/Tabs/Tab.vue";
import AuthService from "@/service/AuthService";
import Tags from "@/components/common/Tags/Tags.vue";
import Tag from "@/components/common/Tags/Tag.vue";
import HolidaysService from "@/service/HolidaysService";
import ITimeTrackingBrand from "@/models/TimeTracking/ITimeTrackingBrand";
import DetailView from "@/views/Service/TimeTracking/Statistics/Components/DetailView.vue";
import IOption from "@/models/IOption";
import Select from "@/components/Form/elements/Select.vue";
import {now} from "moment/moment";


const NAMESPACE_TIME_TRACKING_RECORD: string = 'timeTrackingRecords';
const RESOURCE_TIME_TRACKING_STATISTICS: string = '/tt/statistics';

@Component({
  components: {
    Select,
    DetailView,
    Tag,
    Tags,
    Tab,
    Tabs,
    DropdownItem,
    Dropdown, Input, TimeTrackingStatisticsCard, Panel, TimeTrackingStatisticsToday, VueCtkDateTimePicker
  }
})
export default class TimeTrackingStatistics extends Vue {
  public name: string = "TimeTrackingStatistics";

//  @Action('fetchStatistics', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) fetchStatistics: any;
  @Action('fetchStatisticsCurrentDay', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) fetchStatisticsCurrentDay: any;
  @Action('fetchStatisticsCurrentMonth', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) fetchStatisticsCurrentMonth: any;
  @Action('fetchUsersConfigs', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) fetchUsersConfigs: any;
  @Action('updateUsersConfigs', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) updateUsersConfigs: any;

  @Getter('getStatistics', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) statistics: any;
  @Getter('getStatisticsCurrentDay', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) statisticsCurrentDay: any;
  @Getter('getStatisticsCurrentMonth', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) statisticsCurrentMonth: any;
  @Getter('getUsersConfigs', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) usersConfigs: any;
  @Getter('getRunningRecord', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) runningRecord: any;

  private customTimeRangeFrom: string = '';
  private customTimeRangeTo: string = '';

  private authService: AuthService = new AuthService();
  private currentUserId: any = this.authService.getUserId();

  private timeRangeType: string = 'perMonth';
  private workingHoursPerDay: number = 8;
  private shortTimeWorkPerDayHours: number = 4;
  private workingDaysInWeek: string = '1-5';
  private detailViewVisible: boolean = false;
  private detailViewItem: any = null;
  private totalHoursToday: number = 0;


  private timeRanges: any = {
    'perMonth': {
      'year': 2021,
      'month': 1
    }
  }

  @Watch('usersConfigs', {immediate: true, deep: true})
  private setUsersConfigs() {

    if (this.usersConfigs) {

      this.workingHoursPerDay = this.usersConfigs.hours_per_day ?? this.workingHoursPerDay;
      this.shortTimeWorkPerDayHours = this.usersConfigs.short_time_work_per_day_hours ?? this.shortTimeWorkPerDayHours;
      this.workingDaysInWeek = this.usersConfigs.working_days_in_week ?? this.workingDaysInWeek;

    }

  }

  private get todayWorkingHours(): number {

    let hours: number = 0;

    if (this.isTodayWorkingDay) {

      return this.dailyWorkingHours;

    }

    return hours;

  }

  private get dailyWorkingHours(): number {
    if (this.usersConfigs?.has_short_time_work) {

      return this.shortTimeWorkPerDayHours;

    }

    return this.workingHoursPerDay;
  }

  private doFetchStatisticsCurrentDay(): void {

    this.fetchStatisticsCurrentDay({resource: RESOURCE_TIME_TRACKING_STATISTICS + '/current-day'});

  }

  private doFetchStatisticsCurrentMonth(): void {

    this.fetchStatisticsCurrentMonth({resource: RESOURCE_TIME_TRACKING_STATISTICS + '/current-month'});

  }

  private doFetchUsersConfigs(): void {

    this.fetchUsersConfigs({
      resource: RESOURCE_TIME_TRACKING_STATISTICS + '/users-configs'
    });

  }

  private setTimeTrackingRecordChannel(id: number) {

    this.$echo.private(`TimeTrackingRecord.${id}`)
        .listen('TimeTracking\\UserHasStartedNewRecord', (e) => {

          // this.doFetchStatistics();

        })
        .listen('TimeTracking\\UserHasStoppedNewRecord', (e) => {

          this.doFetchStatisticsCurrentMonth();
          this.doFetchStatisticsCurrentDay();

        })
        .listen('TimeTracking\\UserHasRemovedRecord', (e) => {

          this.doFetchStatisticsCurrentMonth();
          this.doFetchStatisticsCurrentDay();

        });


  }

  private initBroadcastListeners(): void {

    this.setTimeTrackingRecordChannel(this.currentUserId);


  }

  private get isTodayWorkingDay(): boolean {

    // nächster Arbeitstag  return this.$moment('30-01-2015', 'DD-MM-YYYY').nextBusinessDay().format('DD-MM-YYYY');

    return this.$moment().isBusinessDay(); //.format('YYYY-MM-DD HH:mm:ss').isBusinessDay();
  }


  private get businessDaysCountThisMonthYet(): number {

    return this.$moment().businessDaysIntoMonth();

  }

  private get months(): Array<IOption> {

    return AppConfig.getConfig('Selects.month');

  }

  private get years(): Array<IOption> {

    return AppConfig.getConfig('Selects.years');

  }

  private get timeRangesDropdownOptions(): Array<IOption> {

    let options: Array<IOption> = AppConfig.getConfig('Selects.timeRangeTypes');

    options.forEach((option, idx) => {

      options[idx].htmlText = String(this.$t('time_tracking.per_month')) +
          ' (' + String(this.$t('time_tracking.total')) +
          ' ' + this.secsToHours(this.statistics && this.statistics.hasOwnProperty('perMonth') ? this.statistics.perMonth.total : 0) + ')';

    });

    return options;

  }

  private get overTimeHoursTagClass(): string {

    let mClass: string = 'is-warning';

    if (((this.totalHoursToday) - (this.todayWorkingHours)) > 0) {
      mClass = 'is-success';
    } else if (((this.totalHoursToday) - (this.todayWorkingHours)) < 0) {
      mClass = 'is-danger';
    }

    return mClass;

  }

  private setTotalHoursToday(): void {

    let timeDiffMins: number = 0;

    if (this.runningRecord) {

      let start: number = Date.parse(this.runningRecord.start);

      timeDiffMins = ((now() - start) / 1000 / 60);

    }

    let todayTotalSecs: number = this.statisticsCurrentDay ? this.statisticsCurrentDay.total : 0;

    let previousTotalHoursToday: number = Number(this.secsToHours(todayTotalSecs));

    let hours: number = Number((Number((timeDiffMins / 60)) + previousTotalHoursToday));

    console.log('runningRecordMinutes:', Number((timeDiffMins / 60)), previousTotalHoursToday, hours);

    this.totalHoursToday = hours;

  }

  private daysTagClass(day: any): string {

    if (this.$moment(this.$moment().format('YYYY-MM-DD')).isAfter(day, 'day')) {

      return 'is-success';

    } else if (day > this.$moment()) {

      return 'is-danger';

    }

    return 'is-warning';

  }

  private onSelectBrandDetails(brand: ITimeTrackingBrand) {

    this.detailViewVisible = true;
    this.detailViewItem = brand;

  }

  private secsToHours(secs: number, decimals: number = 1): any {

    return (secs / 60 / 60).toFixed(decimals);

  }

  private get minutesSinceRecordStart(): number {

    let timeDiff: number = 0;
    // removed console_log
    if (this.runningRecord) {

      let start: number = Date.parse(this.runningRecord.start);

      timeDiff = ((now() - start) / 1000 / 60);
      // removed console_log
    }

    return timeDiff;

  }


  mounted() {

    this.initBroadcastListeners();

  }


  created() {

    // setInterval(this.doFetchStatisticsCurrentMonth, 1000 * 60 * 60);
    // setInterval(this.doFetchStatisticsCurrentDay, 1000 * 60 * 60);
    setInterval(this.setTotalHoursToday, 1000);

    this.$nextTick(() => {

      this.customTimeRangeFrom = this.$moment().startOf('month').subtract(6, 'months').format(AppConfig.DATETIME_FORMAT_SQL);
      this.customTimeRangeTo = this.$moment().format(AppConfig.DATETIME_FORMAT_SQL);

      //this.doFetchStatistics(this.timeRangeType);
      this.doFetchStatisticsCurrentDay();
      this.doFetchStatisticsCurrentMonth();
      this.doFetchUsersConfigs();
      this.setTotalHoursToday();

      let hs = new HolidaysService();
      hs.getHolidays(this.$moment().format('Y'), 'NW');

    });


  }

}
